import { API } from "../../../utils/api";

export const authentication = async (payload) => {
  const res = await API.post("login", payload.data);
  return res.data;
};
